var map = {
	"./pin1.webp": 5151,
	"./pin10.webp": 6905,
	"./pin11.webp": 830,
	"./pin12.webp": 3279,
	"./pin13.webp": 6188,
	"./pin14.webp": 7261,
	"./pin2.webp": 8510,
	"./pin3.webp": 8185,
	"./pin4.webp": 8032,
	"./pin5.webp": 3795,
	"./pin6.webp": 6146,
	"./pin7.webp": 861,
	"./pin8.webp": 5284,
	"./pin9.webp": 6295,
	"./pinatasImages": 3199,
	"./pinatasImages.jsx": 3199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1965;